const setProgramticFocusAttributes = (target: HTMLElement) => {
    target.setAttribute('tabIndex', '-1');
    target.setAttribute('style', 'outline: none');
};

export const cleanUpProgramaticFocusAttributes = (target: HTMLElement) => {
    target.removeAttribute('tabIndex');
    target.removeAttribute('style');
};

export const moveFocusProgramatically = (target: HTMLElement) => {
    setProgramticFocusAttributes(target);
    target.focus();
    target.scrollIntoView();
};
